import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { registerSkuResourceModulesEnricher } from '../../platform/preset-hydration';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { tcHeadless } from './headless';
import { enrichTcSkuResourceModules } from './hydrateFromApiDetail';
import { TC_RESOURCE_CONFIGS, TC_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('TrainingCluster', TC_SKU_MODULE_META);
registerSkuResourceModulesEnricher('TrainingCluster', enrichTcSkuResourceModules);
registerResourceConfigs('TrainingCluster', TC_RESOURCE_CONFIGS);
registerDeployPlugin({
  headless: tcHeadless,
  loadUi: () => import('./ui').then((module) => ({ ResourceEditor: module.TcResourceEditor, ResourcePreview: module.TcResourcePreview })),
});

export { TC_CAPABILITIES } from './capabilities';
export { TC_FIELD_KEYS } from './fields';
export type { TcFieldKey } from './fields';
export { TC_MODULES, TC_MODULE_MAP } from './modules';
export {
  TC_DIRECT_MERGED_MODULES,
  TC_ORDER_MODULE_TITLE,
  TC_SCENES,
  TC_SKU_MODULE_KEYS,
  TC_SKU_MODULE_LIST,
  TC_SKU_PREVIEW_MODULE_ORDER,
  filterTcSkuModules,
  resolveTcSceneConfig,
} from './scenes';
export type { TcDirectMergedModuleKey } from './scenes';
export { TC_DATA_VOLUME_RESOURCE, TC_RESOURCE_CONFIGS, TC_SKU_MODULE_META } from './resourceConfigs';
export { resetTcSkuModuleFields } from './skuModuleReset';
export { buildTcSkuCapabilityOptions } from './skuCapabilityOptions';
export { filterTrainingClusterTypeOptions } from './trainingClusterRuntimeOptions';
export type { BuildTcSkuCapabilityOptionsInput } from './skuCapabilityOptions';
export { buildTcFreshDisplayConfig, buildTcMergedDisplayConfig, finalizeTcSubmitDisplayConfig } from './display';
export { TC_LINKAGE_RULES, useTcDeployFormLinkage } from './linkage';
export type { TcLinkagePropsMap } from './linkage';
export {
  resolveTcOrderInnerRootWatchFields,
  resolveTcOrderPreviewExtraWatchFields,
  resolveTcSkuPreviewExtraWatchFields,
} from './orderPreviewWatch';
export { TcDirectResourceStep } from './ui/TcDirectResourceStep';
export type { TcDirectResourceStepOptions } from './ui/TcDirectResourceStep';
export { resolveTcDirectPreviewModuleKeys, resolveTcSkuPreviewModuleKeys } from './resolveTcPreviewModuleKeys';
export { enrichTcSkuResourceModules, hydrateTrainingClusterDetailToForm } from './hydrateFromApiDetail';
export { TcResourceEditor, TcResourcePreview } from './ui';
export type { TcResourceEditorProps } from './ui';
export { prepareTrainingClusterSubmit } from './headless/prepareTrainingClusterSubmit';
export { getTrainingClusterSubmitError, readTrainingClusterFormValues } from './headless/trainingClusterSubmitValidation';
export { assertTrainingClusterSubmitReadyOnForm } from './headless/validateSubmit';
export { buildTrainingClusterOrderDeliveryMetadata } from './headless/deliveryMetadata';
export type { BuildTrainingClusterOrderDeliveryMetadataContext } from './headless/deliveryMetadata';
export {
  buildTrainingClusterSharedVolumes,
  buildTrainingClusterSpec,
  findDuplicateTrainingSharedVolumeMountPath,
  getTrainingClusterImage,
  getTrainingClusterSharedVolumes,
} from './headless';
export type { TrainingClusterNetwork, TrainingClusterNic, TrainingClusterSpec } from './headless';
